export enum StorageFromAddressActionTypes {
  STORAGE_SET_IS_RESIDENTIAL = "STORAGE_SET_IS_RESIDENTIAL",
  STORAGE_SET_IS_LIMITED_ACCESS = "STORAGE_SET_IS_LIMITED_ACCESS",
}
